export default __webpack_public_path__ + "static/media/dynamite_explosion.b9e23be8.mp3";